import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TalentIdentification = () => {
    return (
        <Box>
            <Paper sx={{ p: 3 }}>
                <Typography variant="h5" fontWeight={600} gutterBottom>
                    Talent Identification
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    This module is under development. It will help identify student talents across various domains.
                </Typography>
            </Paper>
        </Box>
    );
};

export default TalentIdentification;

